
<v-dialog
    v-model       = "value"
    :max-width    = "width"
    :hide-overlay = "fullScreen"
    :content-class = "contentClass"
    persistent
>
    <v-card
        :class = "fullScreen ? 'full-screen' : ''"
        style="overflow-y: hidden"
    >
        <f-dialog-title
            :title  = "title"
            :icon   = "icon"
            @cancel = "onCancel"
            v-if    = "showHeader"
        >
            <template v-slot:toolbar>
                <slot name="toolbar"></slot>
            </template>
        </f-dialog-title>

        <v-card-text
            :class="inset ? 'pa-3 pt-1 pb-1' : 'pa-0 ma-0'"
        >
            <slot name="content" />
        </v-card-text>

        <f-dialog-actions
            v-if          = "!hideActions"
            :store-label  = "storeLabel"
            :delete-label = "deleteLabel"
            :show-delete  = "showDelete"
            :show-save    = "showSave"
            :show-cancel  = "showCancel"
            @cancel       = "onCancel"
            @store        = "onStore"
            @delete       = "onDelete"
        >
            <template v-slot:pre>
                <slot name="preaction"></slot>
            </template>
        </f-dialog-actions>
    </v-card>
</v-dialog>
